// NOMBRE VISIBLE de una línea de pedido (H9, 23-sep-2026).
//
// El backend ya resolvió el nombre CANÓNICO desde el espejo woo_productos con el mismo
// helper que Analítica (server.mapOrder → analiticaProductos.nombreCanonicoDeLinea): cada
// línea trae `nombre_padre` (padre limpio, sin la variación pegada) y `variacion` (la
// etiqueta legible de la variación). Acá SOLO se elige qué mostrar, sin re-derivar nada:
// - el PADRE es `nombre_padre`; si el backend no lo pobló (pedido sin catálogo), cae al
//   `name` crudo de Woo, que trae «Padre - Opción» — imperfecto pero nunca vacío.
// - la VARIACIÓN es `variacion`; vacía si no hay (producto simple), y entonces no se pinta.
//
// Por qué NO se parte el `name` acá: las opciones pueden contener « - » (medido en
// server.js:mapOrder), así que partir por el guión es la fuente del bug, no la solución.
// El único split posible ya lo hace el backend como ÚLTIMO recurso, con el catálogo por
// encima. Duplicar esa lógica en el front reintroduciría H9 en otra capa.

export function nombrePadreLinea(item) {
  return (item?.nombre_padre || '').trim() || (item?.name || '').trim() || 'Producto';
}

export function variacionLinea(item) {
  return (item?.variacion || '').trim();
}

// Texto compacto «Padre · variación» para listados/resúmenes (una sola línea).
export function nombreLineaCompacto(item) {
  const padre = nombrePadreLinea(item);
  const v = variacionLinea(item);
  return v ? `${padre} · ${v}` : padre;
}
